// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16r04","right":"styles_right__Ob21Q"};